// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ConfirmMessage_infoWrapper__1x9r3","message":"ConfirmMessage_message__VCvRf","buttons":"ConfirmMessage_buttons__2_D67"};